/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import ClickOutHandler from '../../../../OnClickOut';
import CheckIcon from '../../../../../icons/check.svg';

import styles from './SaucesList.styl';

const cx = classNames.bind(styles);

class SaucesList extends PureComponent {
  render() {
    const { isOpen, onHide, className, sauces, disabled, addToCart } = this.props;

    return isOpen && !disabled ? (
      <ClickOutHandler onClickOut={onHide}>
        <div className={cx('SaucesList', className)}>
          <ul className={cx('SaucesList__list')}>
            {sauces.map(sauce => {
              const { variations, name } = sauce;

              const isInStopList = variations.find(variation => variation.isInStopList);

              return isInStopList ? null : (
                <li
                  key={name}
                  className={cx('SaucesList__item')}
                  onClick={() => {
                    addToCart(sauce.variations[0].id);
                  }}
                >
                  <div className={cx('SaucesList__item-check')}>
                    <CheckIcon width={16} height={16} />
                  </div>
                  <div className={cx('SaucesList__item-name')}>{name}</div>
                </li>
              );
            })}
          </ul>
        </div>
      </ClickOutHandler>
    ) : (
      false
    );
  }
}

SaucesList.defaultProps = {
  className: '',
  isOpen: false,
  disabled: false,
};

SaucesList.propTypes = {
  className: PropTypes.string,
  sauces: PropTypes.array.isRequired,
  addToCart: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  disabled: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
};

export default SaucesList;
